export const TIM_CONSUMPTION_DASH_SPEED_POLICY = {
  referenceRatePerSecond: 1,
  slowestPatternPixelsPerSecond: 12,
  fastestPatternPixelsPerSecond: 32,
  rateCompressionExponent: 0.5,
  dashLengthPx: 6,
  dashGapPx: 4,
} as const;

export function resolveTimConsumptionDashCycleDurationMs(
  actualConsumptionRatePerSecond: number,
): number | null {
  if (
    !Number.isFinite(actualConsumptionRatePerSecond) ||
    actualConsumptionRatePerSecond <= 0
  ) {
    return null;
  }

  const normalizedRate = Math.min(
    actualConsumptionRatePerSecond /
      TIM_CONSUMPTION_DASH_SPEED_POLICY.referenceRatePerSecond,
    1,
  );
  const compressedRate = Math.pow(
    normalizedRate,
    TIM_CONSUMPTION_DASH_SPEED_POLICY.rateCompressionExponent,
  );
  const patternPixelsPerSecond =
    TIM_CONSUMPTION_DASH_SPEED_POLICY.slowestPatternPixelsPerSecond +
    (TIM_CONSUMPTION_DASH_SPEED_POLICY.fastestPatternPixelsPerSecond -
      TIM_CONSUMPTION_DASH_SPEED_POLICY.slowestPatternPixelsPerSecond) *
      compressedRate;
  const patternLengthPx =
    TIM_CONSUMPTION_DASH_SPEED_POLICY.dashLengthPx +
    TIM_CONSUMPTION_DASH_SPEED_POLICY.dashGapPx;

  return (patternLengthPx / patternPixelsPerSecond) * 1_000;
}
